module.exports = __webpack_public_path__ + "img/error.84505062.svg";